import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download-export",
  "use": "download-export-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"download-export\"><path fill-rule=\"evenodd\" d=\"M15 9.5v-6H9v6H5l7 7 7-7h-4Zm-10 11h14v-2H5v2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol